import React from 'react';

const maxDisplayedItems = 3;

export const renderFileList = (files, additionalEvidencePage = false) => {
  const showAll = files.length <= maxDisplayedItems + 1;
  const displayList = showAll ? files : files.slice(0, maxDisplayedItems);
  return (
    <ul>
      {displayList.map((file, index) => (
        <li key={index}>{file.name || file.fileName}</li>
      ))}

      {!showAll && (
        <li>
          {files.length - maxDisplayedItems} other{' '}
          {additionalEvidencePage ? 'files' : 'medical records'}
        </li>
      )}
    </ul>
  );
};
